// project imports
// action - state management
import * as actionTypes from "../../actions/actionTypes";
import { getUnitSymbolByUnit, itemType, unitType } from "../types";
import { years } from "store/utils/years";
import { HIRING_PLAN_OTHER_REDUCER_KEY } from "..";
import { getPeriodValue } from "./helpers";
import {
  hp_fp_foundersAndPartnersHeaderMonth,
  hp_other_costPerHeadMonth,
  hp_other_freelancersMonth,
} from "./staticYearsData";

// This is to filter based on company types
import { SaaSCoType, GeneralCoType } from "constants/companyTypes";

const prefix = "hp_other_";

export const OTHER_HEADER_KEY = prefix + "header";
export const HEAD_COUNT_KEY = prefix + "headCount";
export const FREELANCERS_KEY = prefix + "freelancers";
export const COST_PER_HEAD_KEY = prefix + "costPerHead";

export const hiringPlanOtherItems = [
  OTHER_HEADER_KEY,
  HEAD_COUNT_KEY,
  FREELANCERS_KEY,
  COST_PER_HEAD_KEY,
];

export const initialState = {
  [OTHER_HEADER_KEY]: {
    title: "Other",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      const headCount = Number(
        getReducerFunc(HIRING_PLAN_OTHER_REDUCER_KEY)[
          HEAD_COUNT_KEY
        ].calculate(yearKey, getReducerFunc, companyType)
      );
      const costPerHead = getPeriodValue(
        getReducerFunc(HIRING_PLAN_OTHER_REDUCER_KEY)[COST_PER_HEAD_KEY],
        yearKey,
        getReducerFunc
      );

      return headCount * costPerHead;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [HEAD_COUNT_KEY]: {
    title: "Head Count",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.CALCULATION,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      let result = 0;
      for (let i = 2; i < hiringPlanOtherItems.length - 1; i++) {
        result += getPeriodValue(
          getReducerFunc(HIRING_PLAN_OTHER_REDUCER_KEY)[
            hiringPlanOtherItems[i]
          ],
          yearKey,
          getReducerFunc
        );
      }
      return result;
    },
    months: hp_fp_foundersAndPartnersHeaderMonth,
    years: {
      [years.YEAR_1_KEY]: 0,
      [years.YEAR_2_KEY]: 0,
      [years.YEAR_3_KEY]: 0,
      [years.YEAR_4_KEY]: 0,
      [years.YEAR_5_KEY]: 0,
    },
  },
  [FREELANCERS_KEY]: {
    title: "Freelancers",
    unit: unitType.NUMBER,
    unitSymbol: getUnitSymbolByUnit(unitType.NUMBER),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_other_freelancersMonth,
    years: {
      [years.YEAR_1_KEY]: 1,
      [years.YEAR_2_KEY]: 2,
      [years.YEAR_3_KEY]: 2,
      [years.YEAR_4_KEY]: 3,
      [years.YEAR_5_KEY]: 3,
    },
  },
  [COST_PER_HEAD_KEY]: {
    title: "Cost per Head",
    unit: unitType.MONEY,
    unitSymbol: getUnitSymbolByUnit(unitType.MONEY),
    initialPeriod: 0,
    initialPeriodMonth: 0,
    type: itemType.INPUT,
    companyTypes: [SaaSCoType, GeneralCoType],
    calculate: (
      yearKey,
      getReducerFunc,
      companyType = null,
      instanceId = null
    ) => {
      return 0;
    },
    months: hp_other_costPerHeadMonth,
    years: {
      [years.YEAR_1_KEY]: 1500,
      [years.YEAR_2_KEY]: 1500,
      [years.YEAR_3_KEY]: 1500,
      [years.YEAR_4_KEY]: 1500,
      [years.YEAR_5_KEY]: 1500,
    },
  },
};

// ==============================|| SUBSCRIPTION ACQUISITION ASSUMPTIONS REDUCER ||============================== //

const hiringPlanOtherReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.SET_HIRING_PLAN_OTHER_BY_YEAR:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          years: {
            ...state[action.key].years,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.SET_HIRING_PLAN_OTHER_BY_MONTH:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: {
            ...state[action.key].months,
            [action.yearKey]: [action.amount],
          },
        },
      };
    case actionTypes.REPLACE_HIRING_PLAN_OTHER_YEARS:
      return {
        ...state,
        [action.key]: {
          ...state[action.key],
          months: action?.payload,
        },
      };
    case actionTypes.RESET_HIRING_PLAN_OTHER_REDUCER:
      return initialState;
    default:
      return state;
  }
};

export default hiringPlanOtherReducer;
